import React, { useState } from "react";
import LocalizedText from '../presentational/LocalizedText';
import useTranslate from "../../hooks/useTranslate";
import { Button, Checkbox, FormGroup, Input, InputGroup, Intent } from "@careevolution/design-system";
import './SetPassword.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/pro-regular-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

interface SetPasswordProps {
  serverError: string;
  isLoading: boolean;
  emailOrPhone: string;
  rememberMe: boolean;
  productName: string;
  finishJoin: (password: string) => void;
  isValidPassword: (password: string) => boolean;
  setEmailOrPhone: (emailOrPhone: string) => void;
  setRememberMe: (rememberMe: boolean) => void;
}

const SetPassword: React.FC<SetPasswordProps> = ({
  serverError,
  isLoading,
  emailOrPhone,
  rememberMe,
  productName,
  finishJoin,
  isValidPassword,
  setRememberMe,
}) => {
  const [password, setPassword] = useState('')
  const translations = useTranslate(["participant-login-password-label", "participant-login-password-placeholder", "participant-login-remember-me", "participant-login-next-label"])
  const [unmaskPassword, setUnmaskPassword] = useState(false)

  const handleChangePassword = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value)
  }

  const handleChangeRememberMe = (e: React.ChangeEvent<HTMLInputElement>) => {
    setRememberMe(e.target.checked)
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    finishJoin(password)
    return false
  }

  return (
    <form className="login-action set-password" onSubmit={handleSubmit}>
      <h1><LocalizedText textKey="participant-login-set-password-title" /> <span>{productName}</span></h1>
      <p><LocalizedText textKey="participant-login-set-password-info" values={{ emailOrPhone: emailOrPhone }} /></p>
      {
        serverError && (
          <p className="server-error">{serverError}</p>
        )
      }
      <FormGroup className="login-field" label={translations["participant-login-password-label"]}>
        <InputGroup>
          <Input
            onChange={handleChangePassword}
            autoComplete="new-password"
            className="autofocus"
            disabled={isLoading}
            id="resetPassword"
            type={unmaskPassword ? 'text' : 'password'}
            value={password}
            placeholder={translations["participant-login-password-placeholder"]}
            fullWidth={true}
            htmlAttributes={{
              onInput: handleChangePassword,
              spellCheck: false,
              autoCorrect: "off",
              autoCapitalize: "none",
              maxLength: 64,
              autoFocus: true,
            }}
          />
          <button
            type="button"
            onClick={() => setUnmaskPassword(!unmaskPassword)}
            className="password-mask-toggle"
            title="Toggle password visibility">
               <FontAwesomeIcon icon={unmaskPassword ? faEye as IconProp: faEyeSlash as IconProp} />
          </button>
        </InputGroup>
      </FormGroup>
      <Checkbox
        className="login-field checkbox-field"
        id="rememberMe"
        checked={rememberMe}
        onChange={handleChangeRememberMe}
        label={translations["participant-login-remember-me"]}
      />
      <Button
        type="submit"
        onClick={handleSubmit}
        disabled={!isValidPassword(password)}
        intent={Intent.primary}
        className="primary-action"
        width="100%"
        loading={isLoading}
      >
        <span dangerouslySetInnerHTML={{ __html: translations["participant-login-next-label"] }} />
      </Button>
    </form>
  )
}

export default SetPassword